<template>
  <div id="app">
    <router-view></router-view> <!-- Ensure <router-view> is present -->
  </div>
</template>

<script>
export default {
  
}
</script>

<style>
/* Component styles */
</style>